import { lazy } from 'react';
import { Route } from 'react-router';

const TermsPage = lazy(() => import('../pages/MiscPages/TermsPage/TermsPage'));
const AboutUs = lazy(() => import('../pages/MiscPages/AboutUs/AboutUs'));

const AllGamesPage = lazy(
  () => import('@bonanza-social/games/pages/AllGamesPage'),
);

const StatusInfoPage = lazy(async () => ({
  default: (await import('@bonanza-social/status/pages')).StatusInfoPage,
}));
const LevelUp = lazy(() => import('../pages/MiscPages/LevelUp/LevelUp'));
const PrivacyPolicy = lazy(
  () => import('../pages/MiscPages/PrivacyPolicy/PrivacyPolicy'),
);
const Contact = lazy(() => import('../pages/MiscPages/Contact/Contact'));

export const renderMiscRoutes = () => (
  <>
    <Route path="/terms" element={<TermsPage />} />
    <Route path="/level-up" element={<LevelUp />} />

    <Route path="/status" element={<StatusInfoPage />} />
    <Route path="/privacy" element={<PrivacyPolicy />} />
    <Route path="/contact" element={<Contact />} />

    <Route path="/about" element={<AboutUs />} />
    <Route path="/all" element={<AllGamesPage />} />
  </>
);
